<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <worker-cost-shift-page /><br><br><br>
    </div>
  </div>
</template>

    <script>
    import WorkerCostShiftPage from '../../Components/CostShift/WorkerCostShiftPage.vue';
      export default {
        name: 'WorkerCostShift',
        components: {
          'worker-cost-shift-page': WorkerCostShiftPage,
        },
      };
    </script>

    <style scoped>

    </style>
